import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './AdminLeads.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  React.useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => { try { document.head.removeChild(meta); } catch (e) {} };
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { password });
      localStorage.setItem('ri_admin_token', data.token);
      navigate('/admin/leads');
    } catch (err) {
      setError('wrong password. try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="al-page">
      <main className="al-login-card" data-testid="admin-login-card">
        <h1 className="al-login-h">admin · run it leads</h1>
        <p className="al-login-sub">private. password only.</p>
        <form onSubmit={onSubmit} className="al-login-form">
          <label className="al-field">
            <span>password</span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoFocus
              autoComplete="current-password"
              data-testid="admin-password"
            />
          </label>
          {error && <p className="al-error" data-testid="admin-login-error">{error}</p>}
          <button type="submit" className="al-btn al-btn-ink" disabled={loading} data-testid="admin-login-submit">
            {loading ? 'signing in…' : 'sign in →'}
          </button>
        </form>
      </main>
    </div>
  );
};

export default AdminLogin;
